import { SectionOrFilter } from "../filterTypes"
import { messages } from "./messages"

//Fields that you can search by keyword on the search input.
export const stockImportsListFields = [
    "identifier",
    "identifierAnalyzed",
    "identifierNumber",
    "identifierKeyword",
    "status",
]

export const stockImportsListTotals = [
]

export const getStockImportsFilters = (context) => {
    const availableFilters: SectionOrFilter[] =
        [
            {
                section: context.intl?.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: "statuses",
                label: context.intl?.formatMessage(messages["status"]),
                type: "select",
                filterMatch: "status",
                typeOfSelect: "stock-import-status-select",
                placeHolder: context.intl?.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "isArchived",
                label: context.intl?.formatMessage(messages["is_archived"]),
                filterMatch: "isArchived",
                type: "boolean",
                placeHolder: "Show archived",
                initialValue: "",
                initialSelect: "is",
            },
            {
                nameId: "createdAt",
                label: context.intl?.formatMessage(messages["created_at"]),
                filterMatch: "createdAt",
                type: "date",
                initialValue: { startDate: null, endDate: null },
                initialSelect: "is"
            },
        ]
    return availableFilters
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/stockimportFilters/stockDocumentsFilters.ts